module.exports = __webpack_public_path__ + "static/media/short-time-to-go.2be6f82f.jpg";